import React from 'react';
import '../../datatables/DatatablesDefault';
import QrReader from 'react-qr-reader';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Format from '../../utils/Formatter';

class Confirmacao extends React.Component {

  constructor(props) {
      super(props);
      this.handleQrScan = this.handleQrScan.bind(this);
  }

  componentDidMount() {
      $('#cpfInput').mask('000.000.000-00');
  }

  componentWillUpdate() {
      $('#cpfInput').unmask();
  }

  componentDidUpdate() {
      $('#cpfInput').mask('000.000.000-00');
  }

  componentWillUnmount() {
      $('#cpfInput').unmask();
  }

  handleQrError(e) {
      console.error(e);
  }

    handleQrScan(data) {
        if (null != data && this.props.venda.cpfClienteVendas != data) {
            const beepUrl = require('../../../resources/audio/scanner_beep.mp3');
            const snd = new Audio(beepUrl);
            snd.play();
            this.props.events.onUpdateText('cpfClienteVendas', data);
            this.props.events.onFindClientName(data, this.props.token);
        }
    }

  render() {
    const canConfirm = 0 != this.props.venda.nomeCliente.length;
    const qrPreviewStyle = {
        width: 200
    };
    const qrPreview = (
      <div className="col-sm-12  form-group">
        <div style={{"width": qrPreviewStyle.width}} className="center-block">
            <QrReader delay={100} onError={this.handleQrError} onScan={this.handleQrScan} style={qrPreviewStyle}/>
        </div>
      </div>
    );
    const onCpfChanged = (e) => {
        const enteredCpf = $(e.target).cleanVal();
        this.props.events.onUpdateText('cpfClienteVendas', enteredCpf);
        if (enteredCpf.length == 11) {
            this.props.events.onFindClientName(enteredCpf, this.props.token);
        }
    };
    const cpfInput = (
        <div className="col-sm-12  form-group">
            <label htmlFor="cpfInput" className="control-label">CPF:</label>
            <input type="text" id="cpfInput" className="form-control" value={this.props.venda.cpfClienteVendas} onChange={onCpfChanged}/>
        </div>
    );
    const clientName = (
        <div className="col-sm-12  form-group">
            <label htmlFor="nome" className="control-label">Cliente:</label>
            <input type="text" id="nome" className="form-control" readOnly value={this.props.venda.nomeCliente}/>
        </div>
    );
    const onConfirmClick = () => {
        const cartId = this.props.venda.id;
        let promise = this.props.events.onCloseCart(cartId, this.props.venda.cpfClienteVendas, this.props.token);
        if (this.props.app.adminPage === AdminPageTypes.VENDA) {
            promise.then(() => this.props.events.onShowDialog("Sucesso!", "O pedido foi devidamente finalizado."));
        } else {
            promise = promise.then(() => this.props.events.onUpdateOrdersLists(this.props.token));
            promise = promise.then(() => this.props.events.onSelectOpenOrder(cartId, this.props.token));
            promise = promise.then(() => this.props.events.onUpdateText('currentPage', AdminPageTypes.CAIXA));
        }
    };
    const confirmButton = (
      <div className="form-group">
          <button className="btn  btn-primary pull-right" onClick={onConfirmClick} disabled={!canConfirm}>Confirmar</button>
          <div className="clearfix"></div>
      </div>
    );

    return (
      <div className="panel panel-color panel-info">
          <div className="panel-heading">
              <h3 className="panel-title">Finalizando Pedido</h3>
          </div>
          <div className="panel-body">
            <div className="row">{qrPreview}</div>
            <div className="row">{cpfInput}</div>
            <div className="row">{clientName}</div>
          </div>
          <div className="panel-footer">
            {confirmButton}
          </div>
      </div>
    );
  }
}

class ListaItens extends React.Component {

  render() {
    const token = this.props.token;
    const cart = this.props.venda;
    const cartId = cart.id;
    const quantityOnCart = (productId) => {
      const produto = cart.itens.find(i => i.id_produto == productId);
      return (produto) ? produto.quantidade : 0;
    };
    const onAddItemToCart = (produto_id) => {
      const desconto = 0;
      const quantidade = quantityOnCart(produto_id) + 1;
      this.props.events.onUpdateCartItems(cartId, [{produto_id, desconto, quantidade}], token)
    };
    const onRemoveItemFromCart = (produto_id) => {
      const desconto = 0;
      const quantidade = quantityOnCart(produto_id) - 1;
      this.props.events.onUpdateCartItems(cartId, [{produto_id, desconto, quantidade}], token)
    };

    const itens = this.props.items.map(p => (
                    <tr key={p.id}>
                      <td>{p.descricao}</td>
                      <td style={{"width": "20%"}}>{p.preco}</td>
                      <td style={{"width": "20%"}} className="text-center">
                        <button type="button" className="btn btn-sm btn-default"
                            onClick={() => onAddItemToCart(p.id)}>
                          <i className="glyphicon glyphicon-plus"></i>
                        </button>
                        <a className="btn btn-sm btn-default disabled">{quantityOnCart(p.id)}</a>
                        <button type="button" className="btn btn-sm btn-default"
                            disabled={quantityOnCart(p.id) == 0}
                            onClick={() => onRemoveItemFromCart(p.id)}>
                          <i className="glyphicon glyphicon-minus"></i>
                        </button>
                      </td>
                    </tr>
                  )
                );

    return (
      <table className="table  dataTable">
          <thead>
              <tr>
                  <th>Nome</th>
                  <th style={{"width": "20%"}}>Valor</th>
                  <th style={{"width": "20%"}} className="text-center">Qtd</th>
              </tr>
          </thead>
          <tbody>
              {itens}
          </tbody>
      </table>
    );
  }
}

class Pedido extends React.Component {

  constructor(props) {
      super(props);
      this.onFinalizarPedido = this.onFinalizarPedido.bind(this);
  }

  componentDidMount() {
    $('.dataTable').DataTable({
      lengthChange: false,
      info: false,
      pageLength: 10,
      pagingType: "simple_numbers",
      buttons: [],
      columnDefs: [{
          render: Format.money,
          targets: 1
      }]
    });
  }

  onFinalizarPedido() {
    this.props.events.onUpdateText('estadoPedido', 'Finalizando');
  }

  render() {
    const produtos = this.props.produtos.produtos.filter(p => p.categoria == "Produto");
    const cursos = this.props.produtos.produtos.filter(p => p.categoria == "Curso");
    const canCancel = this.props.venda.itens.length > 0;
    const canFinish = canCancel && 'Finalizando' != this.props.venda.estadoPedido;

    const onCancelaPedido = () => this.props.events.onDeleteCart(this.props.venda.id, this.props.token);
    return (
      <div className="panel">
          <div className="panel-heading">
            <ul className="nav nav-pills nav-justified" role="tablist">
                {!!produtos.length &&
                    <li role="presentation" className="active">
                      <a href="#produtos" aria-controls="home" role="tab" data-toggle="pill">Produtos</a>
                    </li>
                }
                {!!cursos.length &&
                    <li role="presentation" className={!produtos.length ? "active" : ""}>
                      <a href="#cursos" aria-controls="profile" role="tab" data-toggle="pill">Cursos</a>
                    </li>
                }
            </ul>

          </div>

          <div className="panel-body">
            <div className="tab-content">
                {!!produtos.length &&
                    <div role="tabpanel" className="tab-pane active" id="produtos">
                      <div className="table-responsive">
                        <ListaItens {...this.props} items={produtos}/>
                      </div>
                    </div>
                }
                {!!cursos.length &&
                    <div role="tabpanel" className={"tab-pane " + (!produtos.length ? "active" : "")} id="cursos">
                      <div className="table-responsive">
                        <ListaItens {...this.props} items={cursos} />
                      </div>
                    </div>
                }
            </div>
          </div>

          <div className="panel-footer">
              <button type="button" className="btn btn-danger" disabled={!canCancel} onClick={onCancelaPedido}>Cancelar</button>
              <button type="button" className="btn btn-primary pull-right" disabled={!canFinish} onClick={this.onFinalizarPedido}>Finalizar Pedido</button>
          </div>
      </div>
    );
  }
}

class Carrinho extends React.Component {

  render() {
    const cart = this.props.venda;
    const itens = cart.itens;
    const total = cart.total;
    const emptyMessage = <tr><td colSpan="4">O Carrinho está vazio :(</td></tr>;
    const itemsToShow = itens.map(p => (
      <tr key={p.id_produto}>
          <td style={{"textAlign": "right"}}>{p.quantidade}x</td>
          <td style={{"width": "3%"}}></td>
          <td>{p.descricao}</td>
          <td style={{"fontWeight": "bold", "textAlign": "right"}}>{Format.money(p.quantidade * p.preco)}</td>
      </tr>
    ));

    return (
      <div className="panel panel-color panel-info">
          <div className="panel-heading">
              <h3 className="panel-title">Carrinho</h3>
          </div>
          <div className="panel-body">
              <div className="list-group">
              </div>
              <table style={{"width" : "100%"}}>
                <tbody>
                  {itens.length ? itemsToShow : emptyMessage}
                </tbody>
            </table>
          </div>
          <div className="panel-footer">
            <h2 className="font-weight-bold text-right">
              Total: {Format.money(total)}
            </h2>
          </div>
      </div>
    );
  }
}

class LojaVendas extends React.Component {

  constructor(props) {
    super(props);
  }

    render() {
        return (
          <div className="wraper container-fluid">
              <div className="row">
                  <div className="col-lg-8">
                    <Pedido {...this.props} />
                  </div>
                  <div className="col-lg-4">
                    <Carrinho {...this.props} />
                    {'Finalizando' === this.props.venda.estadoPedido &&
                      <Confirmacao {...this.props} />
                    }
                  </div>
              </div>
          </div>
        );
    }
}

export default LojaVendas;



// WEBPACK FOOTER //
// src/views/pages/LojaVendas.jsx